const swiperSlider = document.querySelectorAll('.swiper-slider');
swiperSlider.forEach((item) => {
  const swiper = new Swiper(item, {
    direction: 'horizontal',
    loop: true,
    speed: 1200,
    autoplay: {
      delay: 3000,
      disableOnInteraction: true,
    },
    pagination: {
      el: '.swiper-slider .swiper-pagination',
      clickable: true,
    },
  });
});

const upcomingEvents = document.querySelectorAll('.swiper.upcoming-events');
upcomingEvents.forEach((item) => {
  const swiper = new Swiper(item, {
    direction: 'horizontal',
    loop: true,
    breakpoints: {
      1350: {
        slidesPerView: 4,
      },
      1000: {
        slidesPerView: 3.5,
      },
      950: {
        slidesPerView: 2.5,
      },
      750: {
        slidesPerView: 2.2,
      },
      600: {
        slidesPerView: 1.8,
      },
      450: {
        slidesPerView: 1.5,
      },
      0: {
        slidesPerView: 1.3,
      },
    },
    speed: 1200,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
});

const featuredCollection = document.querySelectorAll('.swiper.featured-collection');
featuredCollection.forEach((item) => {
  const swiper = new Swiper(item, {
    direction: 'horizontal',
    loop: true,
    breakpoints: {
      1200: {
        slidesPerView: 4,
      },
      950: {
        slidesPerView: 3.6,
      },
      800: {
        slidesPerView: 3.2,
      },
      650: {
        slidesPerView: 2.6,
      },
      500: {
        slidesPerView: 2.2,
      },
      0: {
        slidesPerView: 1.5,
      },
    },
    speed: 1200,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
});

const relatedProducts = new Swiper('.swiper.related-products', {
  init: false,
  direction: 'horizontal',
  loop: true,
  breakpoints: {
    1350: {
      slidesPerView: 4,
    },
    1000: {
      slidesPerView: 3.5,
    },
    950: {
      slidesPerView: 2.5,
    },
    750: {
      slidesPerView: 2.2,
    },
    600: {
      slidesPerView: 1.8,
    },
    450: {
      slidesPerView: 1.5,
    },
    0: {
      slidesPerView: 1.3,
    },
  },
  speed: 1200,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

const heroBlockBreakpoint = window.matchMedia('(max-width:1000px)');
let heroBlock;

const heroBlockBreakpointChecker = function () {
  if (heroBlockBreakpoint.matches === true) {
    return enableHeroBlock();
  } else if (heroBlockBreakpoint.matches === false) {
    if (heroBlock !== undefined) heroBlock.destroy(true, true);

    return;
  }
};

const enableHeroBlock = function () {
  heroBlock = new Swiper('.hero-block .hero-block__collections .collections', {
    direction: 'horizontal',
    speed: 1200,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      800: {
        slidesPerView: 2.5,
      },
      650: {
        slidesPerView: 2.1,
      },
      450: {
        slidesPerView: 1.8,
      },
      400: {
        slidesPerView: 1.5,
      },
      100: {
        slidesPerView: 1.3,
      },
    },
  });
};

heroBlockBreakpoint.addEventListener('change', heroBlockBreakpointChecker);

heroBlockBreakpointChecker();

const tilesBreakpoint = 1050;
const tiles = document.querySelectorAll('.tiles.swiper.mobile-slider');
tiles.forEach((item) => {
  const swiper = new Swiper(item, {
    init: false,
    direction: 'horizontal',
    loop: true,
    speed: 1200,
    spaceBetween: 50,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      850: {
        slidesPerView: 2.5,
      },
      700: {
        slidesPerView: 2.2,
      },
      550: {
        slidesPerView: 1.8,
      },
      0: {
        slidesPerView: 1.2,
      },
    },
  });

  function windowWidth() {
    if (window.innerWidth <= tilesBreakpoint) {
      swiper.init();
    } else {
      swiper.destroy();
    }
  }

  window.addEventListener('resize', () => {
    windowWidth();
  });

  windowWidth();
});

const membershipListBreakpoint = 1050;
const membershipList = new Swiper('.memberships-wrapper.swiper', {
  init: false,
  direction: 'horizontal',
  slidesPerView: 1,
  loop: true,
  speed: 1200,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    750: {
      slidesPerView: 2.5,
    },
    550: {
      slidesPerView: 1.8,
    },
    400: {
      slidesPerView: 1.5,
    },
    0: {
      slidesPerView: 1.3,
    },
  },
});

window.addEventListener('resize', () => {
  windowWidth();
});

window.addEventListener('recommendationsLoaded', function () {
  relatedProducts.init();
});

function windowWidth() {
  if (window.innerWidth <= membershipListBreakpoint) {
    membershipList.init();
  } else {
    membershipList.destroy();
  }
}

windowWidth();
